import { ENV } from "../utils";

export class Sector {
  baseApi = ENV.BASE_API;

  async getSectors(accessToken, active = true) {
    const url = `${this.baseApi}/sectors?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createSector(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-sector`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateSector(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-sector/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteSector(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-sector/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
